import React from 'react';
import { useSelector } from 'react-redux';

import { getWorkspaceTeammatesIds } from 'Shared/selectors/workspace';
import { useDeepEqualSelector } from 'Shared/utils/hooks';
import { getRecurringMeetingWithoutWorkspaces } from 'Shared/selectors/user';
import { isEmptyString, fullNameFromEmail } from 'Shared/helpers';
import SuggestedTeammateFromCalendar from 'Shared/components/modals/SimpleAddWorkspaceModals/SuggestionsSection/SuggestedTeammateFromCalendar/SuggestedTeammateFromCalendar';
import { getMembersWhoHaveNotTeammateYet } from 'Shared/selectors/members';
import { getBaseTeammateSuggestionList } from 'Shared/components/modals/SimpleAddWorkspaceModals/SuggestionsSection/utils';
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import './WorkspaceTeammatesSuggestionsByEmail.scss';

type Props = {
  identif: string;
  formValues: {};
  isSuggestedListOpened: boolean;
  teammateEmailValue: string;
  onSuggestionClick: Function;
};

function WorkspaceTeammatesSuggestionsByEmail({
  identif,
  formValues,
  isSuggestedListOpened,
  teammateEmailValue,
  onSuggestionClick,
}: Props) {
  const { tr } = useTranslation();
  const { id: currentUserId } = useCurrentUser();
  const members = useSelector(getMembersWhoHaveNotTeammateYet);
  const teammateIds = useDeepEqualSelector(getWorkspaceTeammatesIds);
  const recurringMeetingsWithoutWorkspaces = useDeepEqualSelector(getRecurringMeetingWithoutWorkspaces());
  const teammateSuggestionList = getBaseTeammateSuggestionList({
    includeOrgMembers: false,
    formValues,
    recurringMeetingsWithoutWorkspaces,
    currentUserId,
    teammateIds,
    members,
  });

  const renderList = teammateSuggestionList.filter(({ person, recurringMeeting }) => {
    const foundByPersonName =
      (person.fullName && person.fullName.toLowerCase().includes(teammateEmailValue.toLowerCase())) ||
      (person.email && person.email.toLowerCase().includes(teammateEmailValue.toLowerCase()));

    const foundByMeetingName =
      recurringMeeting &&
      teammateEmailValue
        .toLowerCase()
        .split(' ')
        .filter(n => !isEmptyString(n))
        .some(word => recurringMeeting.name.toLowerCase().includes(word));

    return foundByPersonName || foundByMeetingName;
  });

  const isRender = isSuggestedListOpened && !isEmptyString(teammateEmailValue) && renderList.length;

  if (!isRender) return null;

  return (
    <div className="workspace-teammates-suggestions-by-email position-relative w-100">
      <div className="workspace-teammates-suggestions-by-email-container position-absolute scrollbar w-100">
        <div className="workspace-teammates-suggestions-by-email-title p-2">
          {tr('perform.workspace.suggestions.title')}
        </div>

        {renderList.map(({ recurringMeeting, person, suggestionType }) => (
          <SuggestedTeammateFromCalendar
            key={person.email}
            recurringMeeting={recurringMeeting}
            person={person}
            suggestionType={suggestionType}
            onClick={({ recurringMeetingId, email, fullName }) => {
              onSuggestionClick({
                identif,
                fullName: fullName || fullNameFromEmail(email) || '',
                email,
                recurringMeetingId,
              });
            }}
          />
        ))}
      </div>
    </div>
  );
}

export default WorkspaceTeammatesSuggestionsByEmail;
